module.exports = __webpack_public_path__ + "static/media/bg29.2c5d3a0f.jpg";